var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"main-container--left"},[_c('Aside')],1),_c('div',{staticClass:"main-container--right"},[_c('Header'),_c('div',{staticClass:"content-wrap"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }